import { useEffect, useState } from "react";
import { post } from "../js/post";
import { userData, formatValueUnit } from "../js/utils";
import DataTable from "react-data-table-component";
import {
  CRMCampaignsColumns,
  OpticalValueColumns,
  OpticalValueCurrencyColumns,
  OpticalValueRentabilidadColumns,
  PatientCampaignColumns,
} from "../js/tableColumns";
import InputIconSearchPanelMultiSelection from "./InputIconSearchPanelMultiSelection";
import CheckBox from "./CheckBox";
import Tag from "./Tag";
import ButtonIconH from "./ButtonIconH";
import { useOptics } from "../hooks/useOptics";
import { CRMCampaignStatsInfoBox } from "./CRMCampaignStatsInfoBox";
import { CRMCampaignStatsMetric } from "../support-extra/components/CRMCampaignStatsMetric";
import { CAMPAIGN_METRICS } from "../support-extra/js/constants";

export function CRMCampaignStats({ campaign }) {
  const opticalList = useOptics();
  const [currentStats, setCurrentStats] = useState(null);
  const [totalPatients, setTotalPatients] = useState(0);
  const [patientList, setPatientList] = useState([]);
  const [patientListFixed, setPatientListFixed] = useState([]);
  const [selectedMetricsList, setSelectedMetricsList] = useState([]);
  const [selectedOpticalsList, setSelectedOpticalsList] = useState([]);
  const [searchData, setSearchData] = useState({
    metricas: [],
    opticas: [],
    realizaCompra: false,
    inicio: 0,
  });

  // console.log("ESTADÍSTICAS: ", currentStats);
  // console.log("SEARCH DATA: ", searchData);

  async function getCampaignStats(id) {
    let response = await post("support-extra/crm/EstadisticasCampanaCRM.php", {
      token: userData.token,
      idCampana: id,
    });
    // console.log(
      // "OBTENIENDO ESTADÍSTICAS CAMPAÑA: ",
      // {
        // token: userData.token,
        // idCampana: id,
      // },
      // response,
    // );
    setCurrentStats(response);
  }

  async function getPatientsCampaign(id) {
    const response = await post(
      "support-extra/crm/ListarPacientesCampanaCRM.php",
      {
        token: userData.token,
        idCampana: id,
        opticas: searchData.opticas,
        realizaCompra: searchData.realizaCompra,
        metricas: searchData.metricas,
        start: searchData.inicio,
      },
    );
    // console.log(
      // "LISTANDO PACIENTES: ",
      // {
        // token: userData.token,
        // idCampana: id,
        // opticas: searchData.opticas,
        // realizaCompra: searchData.realizaCompra,
        // metricas: searchData.metricas,
        // start: searchData.inicio,
      // },
      // response,
    // );
    const pacientes = (response.pacientes ?? []).map((p) => ({
      ...p,
    }));
    setTotalPatients(response.totalPacientes);
    if (searchData.inicio === 0) {
      setPatientList(pacientes);
      setPatientListFixed(pacientes);
    } else {
      setPatientList(pacientes);
    }
  }

  useEffect(() => {
    getCampaignStats(campaign.idCampana);
  }, [campaign.idCampana]);

  useEffect(() => {
    setSearchData((prev) => ({
      ...prev,
      inicio: 0,
      metricas: selectedMetricsList.map((m) => m.toLowerCase()),
    }));
  }, [selectedMetricsList]);

  useEffect(() => {
    setSearchData((prev) => ({
      ...prev,
      inicio: 0,
      opticas: opticalList
        .filter((e) => selectedOpticalsList.includes(e.text))
        .map((e) => e.id),
    }));
  }, [selectedOpticalsList]);

  useEffect(() => {
    getPatientsCampaign(campaign.idCampana);
  }, [searchData, campaign.idCampana]);

  useEffect(() => {
    setPatientListFixed((prev) => {
      const newPatients = patientList.filter(
        (patient) =>
          !prev.some(
            (existingPatient) =>
              existingPatient.idPaciente === patient.idPaciente,
          ),
      );

      return [...prev, ...newPatients];
    });
  }, [patientList]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        height: "100%",
        overflowY: "auto",
      }}
    >
      <div className="container-panel">
        <DataTable
          columns={CRMCampaignsColumns}
          data={[campaign]}
          className="custom-datatable non-interactive"
          noDataComponent="No hay campañas disponibles."
        />
      </div>
      {currentStats && (
        <>
          <div
            className="container-panel"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <CRMCampaignStatsInfoBox
                name="Tasa de apertura"
                value={
                  campaign.canal === "SMS"
                    ? "-"
                    : formatValueUnit(currentStats.tasaApertura, "%")
                }
              />
              <CRMCampaignStatsInfoBox
                name="Ventas motivadas"
                value={formatValueUnit(currentStats.ventasMotivadas, "")}
              />
              <CRMCampaignStatsInfoBox
                name="Volumen de ventas"
                value={formatValueUnit(currentStats.volumenVentas, "€")}
              />
              <CRMCampaignStatsInfoBox
                name="Rentabilidad (MCC/MCV)"
                value={formatValueUnit(currentStats.rentabilidad, "%")}
              />
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <div
                className="crm-summary-box-subsection crm-summary-box-border"
                style={{ gap: 10, width: 320 }}
              >
                <div className="section-content-title">Métricas</div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: 10,
                    textAlign: "center",
                  }}
                >
                  <CRMCampaignStatsMetric
                    label="Enviados"
                    value={formatValueUnit(currentStats.enviados, "")}
                  />
                  <CRMCampaignStatsMetric
                    label="Entregados"
                    value={formatValueUnit(currentStats.entregados, "")}
                  />
                  <CRMCampaignStatsMetric
                    label="Abiertos"
                    value={
                      campaign.canal === "SMS"
                        ? "-"
                        : formatValueUnit(currentStats.abiertos, "")
                    }
                  />
                  <CRMCampaignStatsMetric
                    label="Error"
                    value={formatValueUnit(currentStats.error, "")}
                  />
                </div>
              </div>
              <div
                className="crm-summary-box-subsection crm-summary-box-border"
                style={{ gap: 10, width: 320 }}
              >
                <div className="section-content-title">
                  Top ventas por óptica
                </div>
                <DataTable
                  columns={OpticalValueColumns}
                  data={currentStats.ventasMotivadasOpticas}
                  className="custom-datatable"
                  noDataComponent="No hay datos disponibles."
                />
              </div>
              <div
                className="crm-summary-box-subsection crm-summary-box-border"
                style={{ gap: 10, width: 320 }}
              >
                <div className="section-content-title">
                  Volumen ventas por óptica
                </div>
                <DataTable
                  columns={OpticalValueCurrencyColumns}
                  data={currentStats.volumenVentasOpticas}
                  className="custom-datatable"
                  noDataComponent="No hay datos disponibles."
                />
              </div>
              <div
                className="crm-summary-box-subsection crm-summary-box-border"
                style={{ gap: 10, width: 320 }}
              >
                <div className="section-content-title">
                  Rentabilidad por óptica
                </div>
                <DataTable
                  columns={OpticalValueRentabilidadColumns}
                  data={currentStats.rentabilidadOpticas}
                  className="custom-datatable"
                  noDataComponent="No hay datos disponibles."
                />
              </div>
            </div>
          </div>
          <div
            className="container-panel"
            style={{ display: "flex", flexDirection: "column", flex: 1 }}
          >
            <div
              className="opt-table-content grid-10"
              id="search-patient-campaign"
            >
              <div className="cell cell-start-content">Métricas</div>
              <div className="cell">
                <InputIconSearchPanelMultiSelection
                  size={0}
                  tabIndex={10}
                  type={"type-alphanum-ext"}
                  options={CAMPAIGN_METRICS}
                  selectedOptions={selectedMetricsList}
                  onChange={(e) => {
                    setSelectedMetricsList(e);
                  }}
                ></InputIconSearchPanelMultiSelection>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Ópticas</div>
              <div className="cell">
                <InputIconSearchPanelMultiSelection
                  size={0}
                  tabIndex={11}
                  type={"type-alphanum-ext"}
                  options={opticalList.map((e) => e.text)}
                  selectedOptions={selectedOpticalsList}
                  onChange={(e) => {
                    setSelectedOpticalsList(e);
                  }}
                ></InputIconSearchPanelMultiSelection>
              </div>
              <div className="cell"></div>
              <div className="cell cell-start-content">Realiza compra</div>
              <div className="cell">
                <CheckBox
                  tabIndex={12}
                  active={searchData.realizaCompra}
                  onClick={() => {
                    setSearchData((prev) => ({
                      ...prev,
                      inicio: 0,
                      realizaCompra: !prev.realizaCompra,
                    }));
                  }}
                ></CheckBox>
              </div>
              <div className="cell combined-cells-2">
                <button
                  className="cell-label"
                  tabIndex={-1}
                  style={{ width: "120px" }}
                  onClick={() => {
                    setSearchData({
                      metricas: [],
                      opticas: [],
                      realizaCompra: false,
                      inicio: 0,
                    });
                    setSelectedMetricsList([]);
                    setSelectedOpticalsList([]);
                  }}
                >
                  Limpiar filtros
                </button>
              </div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {selectedMetricsList.length > 0 && (
                <span style={{ fontWeight: "500", fontSize: 13 }}>
                  Métricas seleccionadas: {selectedMetricsList.length}
                </span>
              )}
              <div className="tag-content">
                {selectedMetricsList.map((e, i) => {
                  return (
                    <Tag
                      text={e}
                      key={i}
                      tagId={i}
                      onClick={(e) => {
                        setSelectedMetricsList((prev) =>
                          prev.filter((element) => element !== e),
                        );
                      }}
                    ></Tag>
                  );
                })}
              </div>
              {selectedOpticalsList.length > 0 && (
                <span style={{ fontWeight: "500", fontSize: 13 }}>
                  Ópticas seleccionadas: {selectedOpticalsList.length}
                </span>
              )}
              <div className="tag-content">
                {selectedOpticalsList.map((e, i) => {
                  return (
                    <Tag
                      text={e}
                      key={i}
                      tagId={i}
                      onClick={(e) => {
                        setSelectedOpticalsList((prev) =>
                          prev.filter((element) => element !== e),
                        );
                      }}
                    ></Tag>
                  );
                })}
              </div>
              {patientList.length > 0 && (
                <div
                  className="opt-table-title"
                  style={{ marginTop: 10, marginBottom: 0 }}
                >
                  <div>
                    Listado de pacientes (
                    {formatValueUnit(patientListFixed.length)} de{" "}
                    <span style={{ color: "#41b3ff" }}>
                      {formatValueUnit(totalPatients)}
                    </span>
                    )
                  </div>
                </div>
              )}
              <div className="patients-campaign-crm">
                <DataTable
                  columns={PatientCampaignColumns(campaign.canal)}
                  data={patientListFixed}
                  className="custom-datatable dashboard-custom-table"
                  noDataComponent="No hay pacientes."
                />
              </div>
              {patientListFixed.length !== totalPatients && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 10,
                  }}
                >
                  <ButtonIconH
                    text="Ver más (+20)"
                    small={true}
                    onClick={async () => {
                      setSearchData((prev) => ({
                        ...prev,
                        inicio: prev.inicio + 20,
                      }));
                    }}
                  ></ButtonIconH>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
